import { api, companyApi } from "../../index";

export const getSymbol = (clientId) => api.post("/api/Symbols/All", { clientId });
export const getSymbolByName = (clientId, name) => api.post("/api/Symbols/SymbolByName", { clientId, name });
export const getSymbolByID = (clientId, id) => api.post("/api/Symbols/SymbolById", { clientId, id });
export const getChartHistoryData = ({ clientId, symbolId, period, from, to, unixFrom, unixTo }) => api.post("/api/Candles/ChartHistory", { clientId, symbolId, period, from, to, unixFrom, unixTo, });

// TABS
export const getNews = () => api.get("/api/News/All");
export const getTrades = () => api.post("/api/Trades/All");
export const getHistory = (accountId, from, to) => api.post("/api/Accounts/History", { accountId, from, to });

// modal
export const createOrder = (orderData) => api.post("/api/PendingOrders/New", orderData);
export const closeOrder = (data) => api.delete("/api/PendingOrders/Delete", { data: data });
export const orderByID = (id) => api.post('/api/PendingOrders/Order', id)
export const getAllOrders = (accountId) => api.post('/api/PendingOrders/All', { accountId })
export const modifyOrder = (orderData) => api.put("/api/PendingOrders/Update", orderData);


export const getAccountInfo = (clientId) => api.post("/api/Accounts/All", { clientId });
export const getAccountSummary = (id) => { return api.post("/api/Accounts/Summary", { id }); };
export const getAccountHistory = (data) => { return api.post("/api/Accounts/History", data); };
export const getAccount = (id) => { return api.post("/api/Accounts/Account", { id }); };



export const getSymbolGroup = () => { return api.get("/api/SymbolsGroup/All",); };
export const getAmountUnit = (id) => { return api.post("/api/Units/Unit", { id }); };
export const SymbolParameters = (data) => { return api.post("/api/Clients/SymbolParameters", data); };
export const getCompanyInfo = () => { return companyApi.get('licensemgr/api/CompaniesInfo') }
export const getAllSymbolParameters = (id) => { return api.post("/api/Clients/SymbolsParameters", { id }); };
export const getAllAmountUnits = () => { return api.get('/api/Units/All') }


export const getAllEmail = () => { return api.get('/api/Mails/All') }
export const getAllAlerts = (accountId) => { return api.post("/api/Alerts/All", { accountId }); };
export const createAlerts = (data) => { return api.post("/api/Alerts/New", data); };
export const deleteAlert = (data) => { return api.delete("/api/Alerts/Delete", { data: data }); };
export const updateAlert = (data) => { return api.put("/api/Alerts/Update", data); };
export const deleteMail = (id) => { return api.delete("/api/Mails/Delete", { data: id }); };
export const getMail = (id) => { return api.post("/api/Mails/Mail", { id }); };


export const getAllDepartment = (clientId) => { return api.post("/api/Departments/All", { clientId }); };
export const SendToDepartment = (data) => { return api.post("/api/Mails/SendToDepartment", data); };
export const SendToUsername = (data) => { return api.post("/api/Mails/SendToUsername", data); };
export const getStatmentReport = (data) => { return api.post("/api/Accounts/StatementReport", data); };
export const getClientAccountTree = (id) => { return api.post("/api/Clients/ClientTree", { id }); };

//Trading
export const OneClickTrading = (data) => { return api.post("/api/MarketOrders/New", data); };
export const closeOrderPosition = (data) => api.post("/api/MarketOrders/Close", data);
export const getAllPosition = (accountId) => { return api.post("/api/Positions/All", { accountId }); };
export const closeAllPrositionsByHedge = (data) => { return api.post("/api/Batch/CloseAllMarketOrdersByHedge", data); };
export const closePositionByHedge = (data) => { return api.post("/api/MarketOrders/CloseByHedge", data); };

//SLTP orders
export const modifyPositionSLTP = (data) => { return api.post("/api/SLTPOrders/New", data); };
export const getAllSLTPOrders = (accountId) => { return api.post("/api/SLTPOrders/All", { accountId }); };
export const updateSLTPOrders = (data) => { return api.put("/api/SLTPOrders/Update", data); };
export const deleteSLTPOrders = (data) => { return api.delete("/api/SLTPOrders/Delete", { data: data }); };


export const subscribeSocketApi = (accountID) => api.post('/api/WebSocket/Subscribe', { accountID })
export const unsubscribeSocketApi = () => api.get('/api/WebSocket/Unsubscribe')